import { api } from "../Configurations/axios";
import { GeneralInformationFinepModel } from "../Models/GeneralInformationFINEPModel";

const GetByRegistrationDocumentsIdAPI = async (id: string) => {
    try {
        var result = await api.get(`/GeneralInformationFinep/GetByRegistrationDocumentsId/${id}`);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const PostGeneralInformationFinepAPI = async (data: GeneralInformationFinepModel) => {
    try {
        var result = await api.post('/GeneralInformationFinep/Post', data);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const PutGeneralInformationFinepAPI = async (data: GeneralInformationFinepModel) => {
    try {
        var result = await api.put('/GeneralInformationFinep/Put', data);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetByRegistrationDocumentsIdAPI,
    PostGeneralInformationFinepAPI,
    PutGeneralInformationFinepAPI
}